import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
// import { HttpLoaderFactory } from '../../../app.module';
import { FormsModule } from '@angular/forms';
import { RAFormModule } from '../../../ra-form/ra-form.module';
// import { PriceRoutingModule } from './Price-routing.module';
import { PriceComponent } from './Price.component';
import { HttpLoaderFactory } from 'src/app/http-loader-factory';
@NgModule({
imports: [
CommonModule,
// PriceRoutingModule,
RAFormModule,
FormsModule,
HttpClientModule,
TranslateModule.forChild({
loader: {
provide: TranslateLoader,
useFactory: HttpLoaderFactory,// Moved to Seperate File By Mirsha
deps: [HttpClient]
}
}),
],
declarations: [
PriceComponent,
],
exports:[
PriceComponent,
],
})
export class PriceModule { }
